import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FileInputMateDrive, RadioButtons, TabPanel } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { CheckIfFlowUpdated, isActionValueController } from '../../../../helpers/helper';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";
import AutomService from "../../../../services/AutomService/AutomService";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - Text
 * @Param       variables - string variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      Emirhan Bilal YEŞİL
 */
function TextRead({ action, showAlert, setOpenVariable, variables, automId, automVersionId, getVariables }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const label = 'CONTENT.CONFIGURATION-FORM.TEXT.TEXT-READ.';
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext.toLocaleLowerCase() !== 'txt') {
                    showAlert(t(label + 'UPLOAD_TXT_ONLY'));
                    return false;
                }
                return true;
            },
            fileType: '.txt'
        },
        radioButtons: {
            data: [{
                value: 'ro',
                label: label + 'READ-ONLY'
            }, {
                value: 'rw',
                label: label + 'READ-WRITE'
            }],
            defaultValue: 'rw'
        }
    }
    useEffect(() => {
        if (!action.fields.fileType) {
            action.fields.fileType = { value: "FILE" };

        } else {
            if (action.fields.fileType.value === "FILE") {
                setValue(0);
            } else {
                setValue(1)
            }
        }
    }, [action, variables])

    function handleChangeTabs(newValue) {
        if (newValue === 1) {
            action.fields.filePath.type = 'TEXT';
            action.fields.fileType.value = 'TEXT';
            action.fields.filePath.backup = { value: action.fields.filePath.value };
            action.fields.filePath.value = "";
            if (action.fields.filePath.backupText?.value) {
                action.fields.filePath.value = action.fields.filePath.backupText.value;
            }
        } else {
            // action.fields.filePath.type = 'FILE';
            action.fields.fileType.value = 'FILE';

            action.fields.filePath.backupText = { value: action.fields.filePath.value }
            delete action.fields.filePath.value
            if (action.fields.filePath.backup?.value) {
                action.fields.filePath.value = action.fields.filePath.backup.value;
            }
        }
        const field = initialActionsData[action.id]?.fields.fileType;
        const oldValue = !field ? undefined : field.value;
        let v = newValue === 1 ? 'TEXT' : 'FILE';
        CheckIfFlowUpdated("fileType", action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);
        setValue(newValue);
    }

    const handleClick = async () => {
        let res = isActionValueController(action.fields);
        if (res.indexOf(false) === -1) {
            action.automId = automId;
            action.automVersionId = automVersionId;
            let response = await AutomService.runAction(action);
            if (response) {
                if (response.status) {
                    showAlert(t('MESSAGES.AUTOMS.ACTION-RUN-SUCCESSFULLY'), true);
                } else {
                    showAlert(t('FLOW-MESSAGES.LIBRARY.' + response.message), false);
                }
            } else {
                showAlert(t('GENERAL.NETWORK-ERROR'), false);
            }
            getVariables(automVersionId)
        } else {
            showAlert(t('ACTIVE-DIRECTORY.NOT-NULL'), false);
        }
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'FILE-PATH')} is_required />
                <div className="condition-tabs" style={{ marginBottom: 5 }}>
                    <button
                        className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
                        onClick={() => handleChangeTabs(0)}>
                        {t(label + 'SELECT-FILE')}
                    </button>
                    <button
                        className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
                        onClick={() => handleChangeTabs(1)}>
                        {t(label + 'CUSTOM-STRING')}
                    </button>
                </div>
                <TabPanel value={value} index={0}>
                    <FileInputMateDrive action={action} inputName="filePath" options={options.fileInput} isRequired
                        isSize={true} clear={true} hideRequired autom_id={automId} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <TextInput action={action} inputName="filePath" isRequired={false} setOpenVariable={setOpenVariable}
                        variables={variables} autom_id={automId} />
                </TabPanel>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'OPEN-AS')} />
                <RadioButtons action={action} inputName="openAs" options={options.radioButtons} isRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN')} is_required />
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                    filter="string" isRequired hideRequired />
                <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
            <button className="form-button" onClick={() => handleClick()}>Run Once</button>
        </div>
    )
}

export default TextRead;
